module.exports = __webpack_public_path__ + "static/media/mockup-ecom.2394a3d1.jpg";